import React, { useRef } from 'react';
import style from './download-button.module.scss';
export const ProgressButton = props => {
    const { buttonColor = '#386EE7', progressBarColor = '#8FB2FF', progress, onClick, children } = props;
    const progressRef = useRef(null);
    const handleDownload = () => {
        onClick && onClick();
    };
    return (React.createElement("div", { className: style.buttonWrapper, onClick: handleDownload },
        React.createElement("div", { className: style.text }, children),
        React.createElement("div", { style: { width: `${progress}%`, background: buttonColor }, ref: progressRef, className: style.progressBar }),
        React.createElement("div", { className: style.button, style: { background: progress === 0 || progress === 100 ? buttonColor : progressBarColor } })));
};
